import { OpenDialogButton } from '@/components/ConsoleDialog/handlers'
import { PlatformDependent } from '@/components/PlatformDependent'

import { DDE_OperatorFormProps, DDEOperatorForm } from './OperatorForm.dde'
import { DGE_OperatorFormProps, DGEOperatorForm } from './OperatorForm.dge'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const DDEFormButton = ({ defaultValues, ...props }: DDE_OperatorFormProps) => (
  <PlatformDependent dde>
    <OpenDialogButton label="Add Operator">
      <DDEOperatorForm {...props} />
    </OpenDialogButton>
  </PlatformDependent>
)

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const DGEFormButton = ({ defaultValues, ...props }: DGE_OperatorFormProps) => (
  <PlatformDependent streaming>
    <OpenDialogButton label="Add Operator">
      <DGEOperatorForm {...props} />
    </OpenDialogButton>
  </PlatformDependent>
)

export const OperatorFormButton = {
  DDE: DDEFormButton,
  DGE: DGEFormButton
}
